import React, { FC, useEffect, useState, useCallback } from 'react';
import debounce from 'lodash/debounce';

import { LegislationPage } from './page/LegislationPage';
import { Navigation } from './page/components/navigation/Navigation';
import { AppWrapper } from '../../../app/common-app/AppWrapper';
import { PageLayout } from '../../../app/common-app/PageLayout';

import { LegislationProvider } from './LegislationContext';
import { LegislationAllInfosType } from '../legislation.types';

type Props = {
  legislationInfosAll: LegislationAllInfosType;
};

const headerWidth = 120;

const NavigationListener = () => {
  const [show, setShow] = useState(false);

  const onScroll = useCallback(() => {
    const element = document.getElementById('top');

    if (element) {
      const { top } = element.getBoundingClientRect();
      if (top + headerWidth < 0) {
        setShow(true);
      } else {
        setShow(false);
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', debounce(onScroll, 10));
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);

  return show ? <Navigation show={show} /> : null;
};

export const LegislationApp: FC<Props> = ({ legislationInfosAll }) => {
  return (
    <AppWrapper>
      <LegislationProvider legislationInfosAll={legislationInfosAll}>
        <PageLayout subHeader={<NavigationListener />}>
          <LegislationPage />
        </PageLayout>
      </LegislationProvider>
    </AppWrapper>
  );
};
